import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { translocoInitializer } from './transloco-initializer';

/**
 * Provide transloco `APP_INITIALIZER`, which will await translations being loaded
 * before proceeding to the application.
 */
export function provideTranslocoInitializer(): EnvironmentProviders {
	return provideAppInitializer(() => {
		const initializerFn = translocoInitializer(inject(TranslocoService));
		return initializerFn();
	});
}
